/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactevidenceziptimesaved4Inputs */

const en_artifactevidenceziptimesaved4 = /** @type {(inputs: Artifactevidenceziptimesaved4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saves naming, ordering, and zipping every file as Doc. 1, Doc. 2…`)
};

const pt_artifactevidenceziptimesaved4 = /** @type {(inputs: Artifactevidenceziptimesaved4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poupa nomear, ordenar e arquivar cada ficheiro como Doc. 1, Doc. 2…`)
};

/**
* | output |
* | --- |
* | "Saves naming, ordering, and zipping every file as Doc. 1, Doc. 2…" |
*
* @param {Artifactevidenceziptimesaved4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactevidenceziptimesaved4 = /** @type {((inputs?: Artifactevidenceziptimesaved4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactevidenceziptimesaved4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactevidenceziptimesaved4(inputs)
	return pt_artifactevidenceziptimesaved4(inputs)
});
export { artifactevidenceziptimesaved4 as "artifactEvidenceZipTimeSaved" }